const ProcessIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.494 7.968L10.954 0.968A5 5 0 003 5V19A5 5 0 0010.957 23.031L20.497 16.031A5 5 0 0020.494 7.968Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProcessIcon;